import getIsSubchapter from "selectors/getIsSubchapter";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import { createSelector } from "reselect";

const getCompactControlsInactive = (state) => state.inactivity.compactControls;
const getChapterCoverIsShowing = (state) => state.forceChapterCover;

export default createSelector(
  getChapterCoverIsShowing,
  getCompactControlsInactive,
  getIsSubchapter,
  getPlaybackState,
  (
    chapterCoverIsShowing,
    compactControlsInactive,
    isSubchapter,
    playbackState,
  ) =>
    !chapterCoverIsShowing &&
    isSubchapter &&
    ((!compactControlsInactive && playbackState.playing) ||
      !playbackState.playing),
);
